export default "__VITE_ASSET__DcCRZ0Cd__"